export function setAsyncRouteLeaveHook(router, route, hook) {
  let withinHook = false
  let finalResult
  let finalResultSet = false

  router.setRouteLeaveHook(route, nextLocation => {
    withinHook = true
    if (!finalResultSet) {
      hook(nextLocation).then(result => {
        finalResult = result
        finalResultSet = true
        if (!withinHook && nextLocation) {
          // Re-schedule the navigation
          router.push(nextLocation)
        }
      })
    }

    let result = finalResultSet ? finalResult : false
    withinHook = false
    finalResult = undefined
    finalResultSet = false
    return result
  })
}



// WEBPACK FOOTER //
// ./src/utils/router.js